const baseURL = '/api/v1/eas';

export default {
  /**
   * @GET EAS 광고 카테고리 마스터
   * */
  EAS_GET_AD_MASTER_CATEGORIES: `${baseURL}/ad-master/categories`,
  /**
   * @GET EAS 광고 유형 마스터
   * */
  EAS_GET_AD_MASTER_TYPE: `${baseURL}/ad-master/types`,
  /**
   * @GET EAS 광고 매체 마스터
   * */
  EAS_GET_AD_MASTER_MEDIA: `${baseURL}/ad-master/media`,
};
